// Module
var code = "<div class=\"panelContainer\" style=\"flex:1\"> <div id=\"dxGrid\"/> </div> <style></style> ";
// Exports
module.exports = code;